

const Heartbeat = 'Connectivity';
const Sync = 'Sync';
const StagingLoad = 'Staging';
const IntermediateLoad = 'Intermediate';
const ConversionPrep = 'Conversion Prep';
const LeadsGeneration = 'Leads Generation';

export { Heartbeat, Sync, StagingLoad, IntermediateLoad, ConversionPrep, LeadsGeneration }